import { vysePoplatku } from 'helpers/contract/vysePoplatku';
import { Date, Money } from 'modules';
import React, { useMemo } from 'react';
import PlaceSignature from '../components/PlaceSignature';
import { bonatoCompany } from 'constants/company';

interface Content202607Props {
  contract: GQL.IContract;
  form: GQL.IContractOnlineForm;
  formData: any;
}

const Content202607 = ({ contract, form, formData }: Content202607Props) => {
  const provozovna = useMemo(() => contract?.provozovna, [contract]);

  return (
    <>
      <div className="mb-3 text-center">
        <strong>
          OBJEDNÁVKA č. {contract?.cislo} PROGRAM NOVÝ ŽIVOT BEZ DLHOV – BONATO
          <br />
          <small>uzatvorená medzi</small>
        </strong>
      </div>

      <div className="mb-3">
        <u>DODÁVATEĽ:</u>
        <br />
        <div className="indent-text">
          {bonatoCompany.name} {provozovna?.ulice}, {provozovna?.psc} {provozovna?.mesto}
          <br />
          korešpondenčná adresa: {bonatoCompany.contactAddressLine1} {bonatoCompany.contactAddressLine2}
          <br />
          IČO: {bonatoCompany.ic} DIČ: {bonatoCompany.dic}
          <br />
          (ďalej len „BONATO“)
          <br />a
        </div>
      </div>

      <div className="mb-3">
        <u>OBJEDNÁVATEĽ:</u>
        <br />
        <div className="indent-text">
          Meno:{' '}
          <strong>
            {contract?.prijmeni} {contract?.jmeno}
          </strong>
          <br />
          Adresa: {contract?.ulice} {contract?.cislo_popisne}, {contract?.mesto}, {contract?.psc}
          <br />
          Dátum narodenia: {contract?.rc}
          <br />
          Telefón: {contract?.mobil}
          <br />
          E-mail: {contract?.email}
        </div>
      </div>

      <hr />

      <div className="mb-2 text-center">
        <strong>
          <u>I. ÚVOD – OBJEDNÁVKA PROGRAMU NOVÝ ŽIVOT BEZ DLHOV:</u>
        </strong>
      </div>
      <div className="mb-3">
        <div className="mb-2">
          Na základe telefonickej alebo on-line konzultácie s Oddlžovacím poradcom BONATO si KLIENT objednáva program:
        </div>
        <div className="mb-2 text-center">
          <strong>NOVÝ ŽIVOT BEZ DLHOV – BONATO</strong>
        </div>
        Účelom programu je preveriť možnosti oddlženia KLIENTA, navrhnúť najvhodnejší postup a sprevádzať KLIENTA
        procesom návratu k životu bez dlhov. KLIENT berie na vedomie, že:
        <br />
        <div className="indent-text">osobný bankrot ani oddlženie nie sú službou BONATO.</div>
        BONATO poskytuje:
        <ul>
          <li>analýzu,</li>
          <li>vedenie,</li>
          <li>administratívnu podporu,</li>
          <li>vypracovanie dokumentácie,</li>
          <li>koordináciu procesu,</li>
          <li>následnú starostlivosť.</li>
        </ul>
      </div>

      <hr />

      <div className="mb-2 text-center">
        <strong>
          <u>II. ČO SI KLIENT OBJEDNÁVA</u>
        </strong>
      </div>
      <div className="mb-3">
        <p className="paragraph">KLIENT si neobjednáva iba vypracovanie dokumentu</p>
        <p className="paragraph">
          KLIENT si objednáva analýzu, vedenie, systém a podporu pri návrate k normálnemu životu. Predmetom objednávky
          programu NOVÝ ŽIVOT BEZ DLHOV – BONATO je:
        </p>
        <ol className="mb-0">
          <li>analýza životnej, finančnej a majetkovej situácie KLIENTA,</li>
          <li>preverenie možností oddlženia a výber najvhodnejšieho postupu,</li>
          <li>vypracovanie výsledku analýzy vrátane odporúčania ďalšieho postupu,</li>
          <li>
            v prípade odporúčania pokračovať: vyplnenie žiadosti o poskytnutie právnej pomoci vrátane potrebných príloh,
          </li>
          <li>príprava a kompletizácia dokumentácie potrebnej pre proces oddlženia,</li>
          <li>odovzdanie dokumentácie KLIENTOVI na podpis,</li>
          <li>
            po podpise KLIENTOM kontrola a zabezpečenie podania na miestne príslušné pracovisko Centra právnej pomoci,
          </li>
          <li>sledovanie priebehu procesu a informovanie KLIENTA,</li>
          <li>podpora počas procesu,</li>
          <li>servis po ukončení oddlženia.</li>
        </ol>
        BONATO zabezpečuje približne 95 % práce.
        <br />
        KLIENT zabezpečuje približne 5 % práce, najmä:
        <br />
        <ul className="mb-0">
          <li>poskytne pravdivé informácie,</li>
          <li>doloží požadované dokumenty,</li>
          <li>podpíše pripravenú dokumentáciu,</li>
          <li>poskytne potrebnú súčinnosť.</li>
        </ul>
        Cieľom programu je, aby KLIENT nemusel rozumieť zákonom ani administratíve.
        <br />
        BONATO pripraví proces. KLIENT robí rozhodnutia a podpisy.
      </div>

      <hr />

      <div className="mb-2 text-center">
        <strong>
          <u>III. SPÔSOB VSTUPU DO PROGRAMU</u>
        </strong>
      </div>
      <div className="mb-3">
        <p>
          Obsah programu je vo všetkých prípadoch rovnaký.
          <br />
          Rozdiel je iba v spôsobe úhrady a termíne začatia.
        </p>
      </div>

      <hr />

      <div>
        <p className="paragraph">
          <strong>
            1. <u>NOVÝ ŽIVOT HNEĎ</u>
          </strong>
          <br />
          Začatie programu:
          <br />
        </p>
        <p className="paragraph">
          po podpise objednávky a úhrade v deň uzatvorenia.
          <br />
          Cena:
        </p>
        <p className="paragraph">490 € (slovom: štyristodeväťdesiat eur)</p>
      </div>

      <hr />

      <div>
        <p className="paragraph">
          <strong>
            2. <u>NOVÝ ŽIVOT ZA 14 DNÍ</u>
          </strong>
          <br />
          Začatie programu:
          <br />
        </p>
        <p className="paragraph">
          po podpise objednávky a úhrade do 14 kalendárnych dní.
          <br />
          Cena:
        </p>
        <p className="paragraph">590 € (slovom: päťstodeväťdesiat eur)</p>
      </div>

      <hr />

      <div>
        <p className="paragraph">
          <strong>
            3. <u>NOVÝ ŽIVOT NA SPLÁTKY</u>
          </strong>
          <br />
          Cena:
        </p>
        <p className="paragraph">690 € (slovom: šesťstodeväťdesiat eur)</p>
        Prvá splátka:
        <p className="paragraph">po podpise objednávky.</p>
        Začatie programu:
        <p className="paragraph">po úhrade druhej splátky.</p>
        Výška a termíny ďalších splátok budú dohodnuté individuálne.
      </div>

      <hr />
      <p>
        Rozdiel nie je v kvalite programu.
        <br />
        Rozdiel je iba v spôsobe vstupu.
      </p>
      <hr />

      <div className="mb-2 text-center">
        <strong>
          <u>IV. VÝSLEDOK ANALÝZY BONATO</u>
        </strong>
      </div>
      <div>
        Po vykonaní analýzy vznikne jeden z nasledovných výsledkov:
        <p className="paragraph">
          <strong>
            <u>A. GARANCIA PODANIA IHNEĎ</u>
          </strong>
        </p>
        Výsledok analýzy odporučí pokračovanie procesu bez odkladu. BONATO vystaví Garančný list odporúčaného postupu.
        BONATO začne ďalšie kroky.
        <hr />
        <p className="paragraph">
          <strong>
            <u>B. GARANCIA PODANIA S ODKLAD</u>
          </strong>
        </p>
        OM Výsledok analýzy odporučí odklad podania. BONATO určí:
        <ul className="mb-0">
          <li>čo musí byť splnené,</li>
          <li>odporúčaný postup,</li>
          <li>predpokladaný termín pokračovania.</li>
        </ul>
        BONATO vedie KLIENTA do momentu pokračovania.
        <hr />
        <p className="paragraph">
          <strong>
            <u>C. ANALÝZA S ODPORÚČANÍM NEP</u>
          </strong>
        </p>
        OKRAČOVAŤ Analýza preukáže, že pokračovanie aktuálne nie je vhodné
        <br />
        BONATO odporučí ďalší možný postup vrátane programu Správa záväzkov alebo iného vhodného riešenia.
        <br />
        Tento výsledok nie je dôvodom na vrátenie odmeny za vykonanú analýzu.
      </div>

      <hr />

      <div className="mb-2 text-center">
        <strong>
          <u>V. PROGRAM KROK ZA KROKOM</u>
        </strong>
      </div>
      <div>
        <ol className="mb-0">
          <li>Vypracovanie analýzy.</li>
          <li>Odovzdanie analýzy a odporúčania.</li>
          <li>Príprava dokumentácie.</li>
          <li>Vyplnenie žiadosti o poskytnutie právnej pomoci vrátane príloh.</li>
          <li>Odoslanie dokumentácie KLIENTOVI na podpis.</li>
          <li>
            Po prijatí podpísanej dokumentácie vykonanie kontroly a zabezpečenie podania na Centrum právnej pomoci.
          </li>
          <li>Sledovanie priebehu procesu a informovanie KLIENTA.</li>
          <li>Servis po ukončení.</li>
        </ol>
        Pri každom kroku BONATO aktívne vedie KLIENTA.
        <br />
        Cieľom programu je, aby sa KLIENT mohol sústrediť na návrat k normálnemu životu.
      </div>

      <hr />

      <div className="mb-2 text-center">
        <strong>
          <u>VI. LIFEWAY – ŽIVOT PO ODDLŽENÍ</u>
        </strong>
      </div>
      <div>
        KLIENT berie na vedomie, že cieľom programu nie je iba ukončenie dlhov.
        <br />
        Cieľom programu je návrat k normálnemu životu.
        <br />
        BONATO preto poskytuje následnú podporu prostredníctvom programu: <strong>LIFEWAY</strong>
        <br />
        Program LIFEWAY je určený na podporu KLIENTA po ukončení oddlženia a nadväzuje na program NOVÝ ŽIVOT BEZ DLHOV –
        BONATO.
        <br />
        Účelom programu je pomôcť KLIENTOVI:
        <ul>
          <li>zorientovať sa po ukončení oddlženia,</li>
          <li>znížiť riziko návratu do dlhov,</li>
          <li>získať podporu pri praktických otázkach,</li>
          <li>získať väčší pocit kontroly nad financiami,</li>
          <li>podporiť návrat k stabilnému fungovaniu.</li>
        </ul>
        BONATO deklaruje, že nekončí rozhodnutím súdu.
        <br />
        Podpora pokračuje aj po ukončení oddlženia.
      </div>

      <hr />

      <div className="mb-2 text-center">
        <strong>
          <u>VII. ODMENA A SPLATNOSŤ</u>
        </strong>
      </div>
      <div>
        Odmena BONATO predstavuje odmenu za:
        <ul>
          <li>vykonanie analýzy,</li>
          <li>preverenie podmienok,</li>
          <li>kontrolu dostupných registrov,</li>
          <li>výber odporúčaného postupu,</li>
          <li>vypracovanie garančného listu (ak je relevantný),</li>
          <li>vypracovanie (vyplnenie) žiadosti o poskytnutie právnej pomoci vrátane príloh,</li>
          <li>kontrolu podpísanej dokumentácie,</li>
          <li>administratívne zabezpečenie podania na Centrum právnej pomoci,</li>
          <li>koordináciu ďalších krokov.</li>
        </ul>
        Odmena nie je úhradou za rozhodnutie súdu ani za schválenie oddlženia.
        <br />
        Výška odmeny:
        <div className="indent-text">
          NOVÝ ŽIVOT HNEĎ 490 €<br />
          NOVÝ ŽIVOT DO 14 DNÍ 590 €<br />
          NOVÝ ŽIVOT NA SPLÁTKY 690 €
        </div>
        Pri splátkovom režime:
        <ul>
          <li>prvá splátka sa uhrádza po podpise objednávky,</li>
          <li>začatie programu nastáva po úhrade druhej splátky,</li>
          <li>výška a termíny ďalších splátok budú dohodnuté individuálne s Oddlžovacím poradcom</li>
        </ul>
        BONATO začne poskytovať služby po splnení podmienok zvoleného spôsobu vstupu.
        <br />
        Bankové údaje:
        <br />
        IBAN: <strong>{provozovna?.iban_smlouvy}</strong>
        <br />
        Variabilný symbol: <strong>{contract.cislo}</strong>
        <br />
        Špecifický symbol: <strong>{contract.rc?.replace('/', '')}</strong>
      </div>

      <hr />

      <div className="mb-2 text-center">
        <strong>
          <u>VIII. ODOVZDANIE ANALÝZY</u>
        </strong>
      </div>
      <div>
        BONATO odovzdá výsledok analýzy KLIENTOVI:
        <br />
        <p className="paragraph">
          v sekcii On-line BONATO, alebo e-mailom, alebo doporučenou poštovou zásielkou.
          <br />
          Analýza obsahuje najmä:
        </p>
        <ul>
          <li>zhrnutie situácie,</li>
          <li>výsledok preverenia,</li>
          <li>odporúčaný postup,</li>
          <li>výsledok garancie (ak je relevantný),</li>
          <li>ďalšie kroky.</li>
        </ul>
        Predpokladaná lehota odovzdania:
        <br />
        do 5 pracovných dní od splnenia podmienok začatia programu a dodania potrebnej súčinnosti zo strany KLIENTA.
        <br />
        KLIENT bude informovaný SMS alebo e-mailom.
        <br />
        Momentom sprístupnenia analýzy a odporúčaného postupu sa časť služby spočívajúca vo vypracovaní analýzy považuje
        za riadne poskytnutú.
      </div>

      <hr />

      <div className="mb-2 text-center">
        <strong>
          <u>IX. DÔLEŽITÉ UPOZORNENIA</u>
        </strong>
      </div>
      <div>
        KLIENT vyhlasuje, že:
        <ul>
          <li>poskytol pravdivé a úplné údaje,</li>
          <li>nezatajil podstatné skutočnosti,</li>
          <li>bude poskytovať potrebnú súčinnosť.</li>
        </ul>
        BONATO nezodpovedá za:
        <ul>
          <li>nepravdivé alebo neúplné údaje,</li>
          <li>nedodanú dokumentáciu,</li>
          <li>zmenu situácie po vykonaní analýzy,</li>
          <li>rozhodovanie štátnych orgánov.</li>
        </ul>
        BONATO neposkytuje garanciu rozhodnutia súdu.
        <br />
        BONATO poskytuje garanciu odborného vypracovania analýzy, odporúčaného postupu, vyplnenia žiadosti o poskytnutie
        právnej pomoci, prípravy dokumentácie a zabezpečenia podania na Centrum právnej pomoci podľa údajov poskytnutých
        KLIENTOM.
        <br />
        Ak KLIENT neposkytne potrebnú súčinnosť ani po výzve BONATO, BONATO je oprávnené proces prerušiť alebo ukončiť.
        <br />
        Objednávka sa považuje za neúčinnú do momentu splnenia podmienok zvoleného spôsobu vstupu.
      </div>

      <hr />

      <div className="mb-2 text-center">
        <strong>
          <u>X. PODPISY</u>
        </strong>
      </div>
      <div className="mb-5">
        <PlaceSignature contract={contract} form={form} />
      </div>
      <div className="mb-5">
        <strong>
          <u>POTVRDENIE KLIENTA?</u>
        </strong>
        <br />
        Podpisom potvrdzujem, že:
        <ul style={{ listStyleType: 'none' }}>
          <li>✓ rozumiem obsahu objednávky</li>
          <li>✓ bol mi vysvetlený postup</li>
          <li>✓ rozumiem spôsobu vstupu do programu</li>
          <li>✓ rozumiem odplate</li>
          <li>✓ mal som priestor klásť otázky</li>
          <li>✓ rozhodol som sa slobodne a s porozumením</li>
          <li>✓ súhlasím s elektronickým odovzdaním analýzy</li>
          <li>
            ✓ rozumiem, že BONATO pripraví dokumentáciu a po mojom podpise zabezpečí podanie na Centrum právnej pomoci
          </li>
        </ul>
      </div>
    </>
  );
};

export default Content202607;
